export const instructorConstants = {
  VIEW_MODAL: "INSTRUCTOR_VIEW_MODAL",
  APPROVAL_MODAL: "INSTRUCTOR_APPROVAL_MODAL",
  INSTRUCTOR_DATA: "INSTRUCTOR_DATA",
  INSTRUCTORS_DATA: "INSTRUCTORS_DATA",
  SPOT_INSTRUCTORS_DATA: "SPOT_INSTRUCTORS_DATA",
  INSTRUCTOR_SPORTS: "INSTRUCTOR_SPORTS",
  INSTRUCTOR_CENTER_DETAIL: "INSTRUCTOR_CENTER_DETAIL",
  GET_ALL_CENTER_INSTRUCTORS: "GET_ALL_CENTER_INSTRUCTORS",
};
